import('./bootstrap').catch(err => console.error(err));
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
